import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class ToDoService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('ToDo');
	}
	
	loadAll() : Observable<ePM.Logic.IToDo[]> {
		return this.myBaseService.loadAll(this.url);
	}
}